<template>
  <div class="gewerbe-person">

    <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
           no-gutters>

      <!-- Herr / Frau mit Titel -->
      <v-col v-if="isUsed('anrede')"
             cols="12"
             sm="11">
        <v-radio-group v-model="anrede"
                       v-validate="'required'"
                       :error-messages="errors.collect('anrede')"
                       :disabled="disabled"
                       hide-details
                       data-vv-as="Anrede"
                       data-vv-name="anrede"
                       name="anrede"
                       >
          <v-row no-gutters>
            <v-radio label="Frau"
                     value="F"
                     color="primary" />
            <v-radio label="Herr"
                     value="H"
                     color="primary" />
            <v-radio label="keine Angabe"
                     value="kA"
                     color="primary" />
          </v-row>
        </v-radio-group>
      </v-col><v-col cols="0" sm="1"/>

      <v-col v-if="isUsed('titel')"
             cols="12"
             sm="6">
        <dmb-combobox v-model="titel"
                        v-dmb-trim
                        :error-messages="errors.collect('titel')"
                        :items="titelList"
                        data-vv-as="Titel"
                        data-vv-name="titel"
                        :name="random123('titel')"
                        label="Titel"/>
      </v-col><v-col cols="0" sm="6"/>

      <v-col cols="12"
             sm="6"
             @click="showSnackbar" >
        <v-text-field v-model="firstname"
                      v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{1,}$/ }"
                      v-dmb-trim
                      :error-messages="errors.collect('firstname')"
                      :disabled="disabled"
                      data-vv-as="Vorname"
                      class="required"
                      name="firstname"
                      label="Vorname" />
      </v-col>

      <v-col cols="12"
             sm="6"
             @click="showSnackbar">
        <v-text-field v-model="lastname"
                      v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{1,}$/ }"
                      v-dmb-trim
                      :error-messages="errors.collect('lastname')"
                      :disabled="disabled"
                      data-vv-as="Nachname"
                      class="required"
                      name="lastname"
                      label="Nachname" />
      </v-col>

      <template v-if="isUsed('staat')" >
        <v-col cols="12"
               sm="6">
          <v-autocomplete v-model="staat"
                          v-validate="'required'"
                          :error-messages="errors.collect('staat')"
                          :disabled="disabled"
                          :items="countryList"
                          auto-select-first
                          data-vv-as="Staatsangehörigkeit Land"
                          data-vv-name="staat"
                          class="required"
                          :name="random123('staat' + key)"
                          label="Staatsangehörigkeit Land" />
        </v-col><v-col cols="0" sm="6"/>
      </template>

      <template v-if="isUsed('adresse')">

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="strasse"
                        v-validate="{ required: true, regex: /^[^!§$%&\/()=?#*+{\[\]}]*$/ }"
                        v-dmb-trim
                        :error-messages="errors.collect('strasse')"
                        :disabled="disabled"
                        data-vv-as="Straße"
                        class="required"
                        name="strasse"
                        label="Straße" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="hausnummer"
                        v-validate="{ required: true, regex: /^[1-9][0-9a-zA-Z-\/,]*$/ }"
                        v-dmb-trim
                        :error-messages="errors.collect('hausnummer')"
                        :disabled="disabled"
                        data-vv-as="Hausnummer"
                        class="required"
                        name="hausnummer"
                        label="Hausnummer"
                        @change="restrictHausnummer" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="adresszusatz"
                        v-dmb-trim
                        :disabled="disabled"
                        data-vv-as="Adresszusatz"
                        name="adresszusatz"
                        label="Adresszusatz" />
        </v-col><v-col cols="0" sm="6"/>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="plz"
                        v-validate="{ required: true, min:5, max:5, numeric:true }"
                        :error-messages="errors.collect('plz')"
                        :disabled="disabled"
                        data-vv-as="Postleitzahl"
                        class="required"
                        name="plz"
                        label="Postleitzahl"
                        @input="onInputPlz" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-if="cityList.length === 0"
                        v-model="ort"
                        v-validate="{ required: true, regex: regex.ort }"
                        v-dmb-trim
                        :error-messages="errors.collect('ort')"
                        :disabled="disabled"
                        data-vv-as="Ort"
                        class="required"
                        name="ort"
                        label="Ort"
                        hint="Hauptwohnsitz in Deutschland" />
          <v-combobox v-else
                      v-model="ort"
                      v-validate="{ required: true, regex: regex.ort }"
                      v-dmb-trim
                      :error-messages="errors.collect('ort')"
                      :disabled="disabled"
                      :items="cityList"
                      data-vv-as="Ort"
                      data-vv-name="ort"
                      :name="random123('ort' + key)"
                      class="required"
                      label="Ort"
                      hint="Hauptwohnsitz in Deutschland" />
        </v-col>

      </template>

      <!-- Beruf und Info -->
      <template v-if="isUsed('beruf')">

        <v-col cols="12"
               sm="6" style="overflow-x: hidden;">
          <dmb-combobox v-model="beruf"
                      v-validate="{ required: true, regex: /^[^0-9!§$%&=?#*+{\[\]}]*$/ }"
                      v-dmb-trim
                      :rules="[(beruf !== '' || 'Beruf ist ein Pflichtfeld')]"
                      :error-messages="errors.collect('beruf')"
                      :disabled="disabled"
                      :items="berufe"
                      class="required"
                      data-vv-as="Beruf"
                      data-vv-name="beruf"
                      :name="random123('beruf' + key)"
                      label="Beruf"
                      hint="Bitte Beruf eingeben oder auswählen" />
        </v-col><v-col cols="0" sm="6"/>

      </template>


      <!-- Telefon und Mobil -->
      <template v-if="isUsed('kontakt')">

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="telefon"
                        v-validate="{regex: regex.telefon }"
                        v-dmb-trim
                        :error-messages="errors.collect('telefon')"
                        :disabled="disabled"
                        data-vv-as="Festnetz- / Mobilnummer"
                        name="telefon"
                        label="Festnetz- / Mobilnummer" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="mobil"
                        v-validate="{ regex: regex.telefon }"
                        v-dmb-trim
                        :error-messages="errors.collect('mobil')"
                        :disabled="disabled"
                        data-vv-as="Festnetz- / Mobilnummer"
                        name="mobil"
                        label="Alternative Festnetz- / Mobilnummer" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="email"
                        v-validate="'email'"
                        v-dmb-trim
                        :error-messages="errors.collect('email')"
                        :disabled="disabled"
                        data-vv-as="E-Mail Adresse"
                        name="email"
                        label="E-Mail" />
        </v-col>

      </template>

    </v-row>

    <template v-if="withMvp">

      <v-row no-gutters
             class="mb-2">
        <v-col cols="12"
               sm="6">
        <span class="dmb-form-text">Mitversicherte Person (Lebenspartner/in)
        </span>
        </v-col>
        <v-col cols="12"
               sm="6">
          <v-radio-group v-model="hasMvp"
                         row
                         hide-details
                         class="pa-0" >
            <v-radio label="Ja"
                     name="hasmvpyes"
                     :value="true"/>
            <v-radio label="Nein"
                     name="hasmvpno"
                     :value="false"/>
          </v-radio-group>
        </v-col>
      </v-row>

      <template v-if="hasMvp && mvpKey">
        <gewerbe-person :state-path="$store.getters.personPath(mvpKey)" :unused="['adresse', 'kontakt', 'staat']"></gewerbe-person>
      </template>

    </template>

  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import Proffession from "@/store/config/proffessions";
import countries from "@/store/config/countries";
import titelArray from "@/store/config/titel";
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import {mapGetters} from "vuex";
import REGEX from "@/validation/regexes";

export default {
  name: 'GewerbePerson',
  mixins: [ValidationMixin, twowayBinding, plzOrtMixin],
  props: {
    used: {
      type: Array,
      default: null
    },
    unused: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withMvp: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      berufe: Proffession.jobs,
      countryList: countries.countryList,
      titelList: titelArray.titelList,
      regex: REGEX
    };
  },
  computed: {
    ...mapTwoWay([
      'key',
      'anrede',
      'titel',
      'firstname',
      'lastname',
      'strasse',
      'hausnummer',
      'adresszusatz',
      'plz',
      'ort',
      'beruf',
      'email',
      'telefon',
      'mobil',
      'staat'
    ]),
    ...mapTwoWay([
      'hasMvPerson'
    ], {}, 'gewerbe.ui'),
    ...mapGetters([
      'mvPersonen'
    ]),
    hasMvp: {
      get() {
        return this.hasMvPerson.indexOf(this.key) > -1;
      },
      set(value) {
        if (value) {
          this.$store.commit('addMvPerson', { gf: this.key });
        } else {
          this.hasMvPerson = this.hasMvPerson.filter(k => k !== this.key);
        }
      }
    },
    mvpKey() {
      const mvp = this.mvPersonen.find(p => p.ref === this.key);
      return mvp ? mvp.key : null;
    }
  },
  methods: {
    isUsed(field) {
      if (this.used) {
        return this.used.indexOf(field) > -1;
      } else if (this.unused) {
        return this.unused.indexOf(field) < 0;
      }
      return true;
    },
    showSnackbar() {
      if (this.disabled) this.$store.dispatch('gewerbeShowKompexHint');
    },
    restrictHausnummer() { 
      this.hausnummer = this.hausnummer.replace(/[^0-9a-zA-Z-/,]/g, ""); //on blur change
    }
  }
};
</script>
<style>
  .v-list-item {
    min-height: 36px !important; /* overwrite vuetify from 48px */
  }
  .v-list-item__content{
    padding-bottom: 8px;  /* overwrite vuetify from 12px */
    padding-top: 8px;
  }
</style>